/** What Bekijken mode says (ADR-058), in Dutch. */
export const BEKIJKEN_TEXT = {
  loading: (title: string): string => `${title} wordt geladen…`,
  gone: 'Deze weergave is verlopen; stuur hem opnieuw.',
  failed: 'Deze weergave kon niet worden geladen.',
  close: 'Sluiten',
  still: 'Stil',
  look: 'Bekijken',
  lookAround: 'Kijk rond.',
  walkAround: 'Loop eromheen en bekijk het van alle kanten.',
  rooms: 'Rondkijken',
  roomsText: 'Loop door de kamers met de knoppen naast het bord.',
  /** The lobby of one of the platform's test headsets (ADR-058). */
  platformTitle: 'Testheadset van het platform',
  platformLead: 'Stuur een wereld of object vanuit de console met "Open in Quest".',
} as const;

/** A clip's name as a button says it: `brullen` → `Brullen`. */
export const clipLabel = (clip: string): string => clip.charAt(0).toUpperCase() + clip.slice(1);
